import { PERMISSIONS } from '@conversed/shared/src/central/constants/permissions';
import { z } from 'zod';

import { createRESTContract } from '../../index';
import { GDPRUserSchema, GDPRUserSendSchema } from './gdpr.schema';

export const gdprContract = createRESTContract({
  getGDPRUsers: {
    method: 'GET',
    path: 'GDPR',
    permissions: [PERMISSIONS.GDPR.GDPR_LIST],
    query: z.object({
      filter: z.string().optional(),
      page: z.string(),
      perPage: z.string(),
    }),
    response: GDPRUserSchema,
  },
  deleteGDPRUser: {
    method: 'DELETE',
    path: '/GDPR/:id',
    permissions: [PERMISSIONS.GDPR.GDPR_DELETE],
    response: z.object({
      success: z.boolean(),
    }),
    body: z.undefined(),
  },
  sendGDPREmailToUser: {
    method: 'POST',
    path: '/GDPR/request',
    permissions: [PERMISSIONS.GDPR.GDPR_SEND],
    body: GDPRUserSendSchema,
    response: z.void(),
  },
  requestUserGDPRData: {
    method: 'GET',
    path: '/GDPR/request/:id',
    auth: false,
    query: z.object({ email: z.string().email(), companyId: z.string() }),
    response: z.string(),
  },
  requestUserGDPRDataDeletion: {
    method: 'DELETE',
    path: '/GDPR/request/:id',
    auth: false,
    query: z.object({ email: z.string().email(), companyId: z.string() }),
    body: z.undefined(),
    response: z.object({
      success: z.boolean(),
    }),
  },
});
